/*
  Because of the way we are breaking out of our main container for full width items, the only method
  available was to use "vw" units, which are based on the viewport width.

  The viewport width is calculated exclusive of scrollbars, so we originally had an issue where the width on Windows Chrome-based browsers was either not quite making it to the edge of the page, or causing a slight horizontal scroll, depending on the height of the document.

  This will determine any difference between the width of the document element and the window width, which in theory will be the width of any scrollbars present.
*/
const scrollbarWidth = () => {
  document.documentElement.style.setProperty('--scrollbar-width', window.innerWidth - document.documentElement.clientWidth);
}

export {
  scrollbarWidth
}